export class GetUserModel {
    limit: number = 0;
    page: number = 0;
    sorttype: number = 0;
    sortcol: string = "";
    email: string;
    usernamesearch: string = "";
    companynamesearch: string = "";
    phonenumbersearch: string = "";
    provincesearch: string = "";
    countrysearch:  string = "";
    status: string = "";
    startDate?: Date;
    endDate?: Date;
    userInactiveStatus: number;
    referralCode?: string[];
}
export class UserListIndexModel {
    data: Array<UserlistModel> = new Array<UserlistModel>();
    count: number = 0;
}
export class UserlistModel {
    userSurrKey: number = 0;
    userName: string = "";
    userSurName: string = "";
    userEmail: string = "";
    userPhone: string = "";
    createdDateUser: string = "";
    createdDateEmployee: string = "";
    companySurrkey: number = 0;
    companyName: string = "";
    roles: string = "";
    isRegister: boolean;
}
export class GetUserStatusModel {
  countUser : number;
  status : boolean;
}

